/// <amd-module name="VSS/Features/PlatformUI/Components/MessageDialog/MessageDialog" />
import * as React from "react";
import * as Resources from "VSS/Features/PlatformUI/Resources";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssLayoutManager, WrappedComponent } from "VSS/Platform/Layout";
import { IButtonProps } from "VSSUI/Button";
import { IDialogProps } from "VSSUI/Dialog.Types";
import { getSafeId } from "VSSUI/Util";
import { IMessageDialogProps } from "./MessageDialog.Props";

let idCounter = 1;

export const MessageDialog = (props: IMessageDialogProps) => {
    const dialogContentId = `message-dialog-dialog-content-${idCounter++}`;
    const dialogProps: IDialogProps = {
        ariaDescribedBy: dialogContentId,
        lightDismiss: props.lightDismiss !== false,
        onDismiss: () => {
            props.onClose(false);
        },
        role: "alertdialog",
        titleProps: {
            text: props.title
        }
    };

    const styleProp: React.CSSProperties = {maxWidth: "217px"};
    const buttons: IButtonProps[] = [];
    
    if (props.showCancel !== false) {
        const cancelButton: IButtonProps = { id: `message-dialog-cancel-button-${idCounter}`, text: Resources.cancel, style: styleProp, ...props.cancelButtonProps };
        cancelButton.onClick = () => {
            props.onClose(false);
        };
        buttons.push(cancelButton);
        dialogProps.defaultActiveElement = "#" + cancelButton.id;
    }

    const okButton: IButtonProps = { id: `message-dialog-ok-button-${idCounter}`, text: Resources.ok, style: styleProp, primary: true, ...props.okButtonProps };
    okButton.onClick = () => {
        props.onClose(true);
    };
    buttons.push(okButton);

    if (!dialogProps.defaultActiveElement) {
        dialogProps.defaultActiveElement = "#" + okButton.id;
    }

    dialogProps.footerButtonProps = buttons;

    // If cancel button is shown, we make it default active element,
    // otherwise ok button becomes default active element
    dialogProps.defaultActiveElement = `#${getSafeId(buttons[0].id)}`;

    return (
        <WrappedComponent dependencies={["ms.vss-features.ui-layer-content"]} wrappedType="dialog" wrappedProps={dialogProps}>
            <div id={getSafeId(dialogContentId)}>{props.message}</div>
        </WrappedComponent>
    );
};

/**
 * Opens a message dialog
 *
 * @param pageContext Page context
 * @param props Message dialog properties
 */
export function showMessageDialog(pageContext: IVssPageContext, props: IMessageDialogProps): void {
    const layoutManager = pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
    layoutManager.renderCallout(onDismiss => (
        <MessageDialog
            {...props}
            onClose={result => {
                props.onClose(result);
                onDismiss();
            }}
        />
    ));
}
